// src/components/Admin/BoardGroupManager/CategoryForm.jsx
import { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, FormControlLabel, Switch,
} from '@mui/material';

import {
    createBoardGroup,
    editBoardGroup,
} from '../../../api/admin';           // api 함수 ⬅︎ 꼭 추가하세요!

/* ───────── 기본값 ───────── */
const defaultForm = {
    name: '',
    emoji: '📋',
    is_active: true,
};

export default function GroupCategoryForm({
    open,
    onClose,
    group,          // 수정 시 전달되는 기존 객체
    isEdit,
    reload,         // 목록 재조회 콜백
}) {
    const [form, setForm] = useState(defaultForm);

    /* ---------- 초기값 세팅 ---------- */
    useEffect(() => {
        if (isEdit && group) {
            setForm({ ...defaultForm, ...group });
        } else {
            setForm(defaultForm);
        }
    }, [group, isEdit, open]);

    /* ---------- 입력 핸들 ---------- */
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    /* ---------- 저장 ---------- */
    const handleSubmit = () => {
        if (!form.name.trim()) {
            alert('그룹명을 입력하세요.');
            return;
        }

        const apiCall = isEdit
            ? editBoardGroup(form.id, form)
            : createBoardGroup(form);

        apiCall
            .then(() => {
                reload();     // 목록 새로고침
                onClose();
            })
            .catch(() => alert('저장 실패'));
    };

    /* ---------- UI ---------- */
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEdit ? '그룹 수정' : '그룹 추가'}</DialogTitle>

            <DialogContent
                sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}
            >
                <TextField
                    name="name"
                    label="그룹명"
                    value={form.name}
                    onChange={handleChange}
                    fullWidth
                    required
                />

                <TextField
                    name="emoji"
                    label="이모지 (예: 📋 📁)"
                    value={form.emoji}
                    onChange={handleChange}
                    inputProps={{ maxLength: 2 }}
                />

                <FormControlLabel
                    control={
                        <Switch
                            name="is_active"
                            checked={form.is_active}
                            onChange={handleChange}
                        />
                    }
                    label={form.is_active ? '노출중' : '숨김'}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>취소</Button>
                <Button variant="contained" onClick={handleSubmit}>
                    {isEdit ? '수정' : '추가'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
